import React from "react";
import { X } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export const DeleteX = ({ onConfirm, testId = "delete-x", title = "حذف هذا المحتوى؟", desc = "لا يمكن التراجع عن الحذف.", className = "" }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      <button type="button" aria-label="حذف" data-testid={testId}
        className={`w-7 h-7 rounded-full bg-red-600 hover:bg-red-700 text-white flex items-center justify-center shadow-lg transition-transform hover:scale-110 ${className}`}>
        <X className="w-4 h-4" strokeWidth={3} />
      </button>
    </AlertDialogTrigger>
    <AlertDialogContent className="bg-popover border-border" dir="rtl">
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        <AlertDialogDescription>{desc}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter className="gap-2">
        <AlertDialogCancel data-testid={`${testId}-cancel`}>إلغاء</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} className="bg-red-600 hover:bg-red-700 text-white" data-testid={`${testId}-confirm`}>حذف</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
